import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";

export default function AdminAnalyticsTab({ apiUrl, getAuthHeaders }) {
  const credFetch = (url, opts = {}) => fetch(url, { ...opts, credentials: "include" });

  const [analytics, setAnalytics] = useState(null);
  const [toolAnalytics, setToolAnalytics] = useState(null);

  useEffect(() => { loadAnalytics(); }, []);

  const loadAnalytics = async () => {
    try {
      const [overview, tools] = await Promise.all([
        credFetch(`${apiUrl}/api/admin/analytics/overview`, { headers: getAuthHeaders(), credentials: "include" }).then((r) => r.json()),
        credFetch(`${apiUrl}/api/admin/analytics/tools`, { headers: getAuthHeaders(), credentials: "include" }).then((r) => r.json()),
      ]);
      setAnalytics(overview);
      setToolAnalytics(tools);
    } catch (error) { console.error("Analytics error:", error); }
  };

  if (!analytics) return (
    <div className="flex items-center justify-center h-64">
      <div className="animate-spin w-8 h-8 border-4 border-violet-500 border-t-transparent rounded-full" />
    </div>
  );

  return (
    <div className="space-y-6" data-testid="admin-analytics-tab">
      <h2 className="text-2xl font-bold text-gray-900">Analytics</h2>
      <div className="grid grid-cols-4 gap-6">
        <Card className="p-6 text-center"><p className="text-3xl font-bold text-violet-600">{analytics.metrics.page_views.toLocaleString()}</p><p className="text-sm text-gray-500">Page Views</p></Card>
        <Card className="p-6 text-center"><p className="text-3xl font-bold text-blue-600">{analytics.metrics.unique_visitors.toLocaleString()}</p><p className="text-sm text-gray-500">Unique Visitors</p></Card>
        <Card className="p-6 text-center"><p className="text-3xl font-bold text-green-600">{analytics.metrics.avg_session_duration}</p><p className="text-sm text-gray-500">Avg. Session</p></Card>
        <Card className="p-6 text-center"><p className="text-3xl font-bold text-orange-600">{analytics.metrics.bounce_rate}</p><p className="text-sm text-gray-500">Bounce Rate</p></Card>
      </div>
      <div className="grid grid-cols-2 gap-6">
        <Card className="p-6">
          <h3 className="font-semibold mb-4">Top Pages</h3>
          <div className="space-y-3">
            {analytics.top_pages.map((page, i) => (
              <div key={i} className="flex justify-between items-center"><span className="text-sm text-gray-600">{page.page}</span><span className="font-medium">{page.views.toLocaleString()}</span></div>
            ))}
          </div>
        </Card>
        <Card className="p-6">
          <h3 className="font-semibold mb-4">Traffic Sources</h3>
          <div className="space-y-3">
            {analytics.traffic_sources.map((source, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="flex-1">
                  <div className="flex justify-between mb-1"><span className="text-sm">{source.source}</span><span className="text-sm font-medium">{source.percentage}%</span></div>
                  <div className="w-full bg-gray-200 rounded-full h-2"><div className="bg-violet-600 h-2 rounded-full" style={{ width: `${source.percentage}%` }} /></div>
                </div>
              </div>
            ))}
          </div>
        </Card>
      </div>
      {toolAnalytics && (
        <Card className="p-6">
          <h3 className="font-semibold mb-4">Tool Usage</h3>
          <div className="grid grid-cols-4 gap-4">
            {toolAnalytics.tool_usage.map((tool, i) => (
              <div key={i} className="p-4 bg-gray-50 rounded-lg"><p className="text-xl font-bold text-gray-900">{tool.usage.toLocaleString()}</p><p className="text-sm text-gray-500">{tool.tool}</p><p className="text-xs text-green-600">{tool.growth}</p></div>
            ))}
          </div>
        </Card>
      )}
    </div>
  );
}
